import type { LucideIcon, LucideProps } from 'lucide-react'
import { createElement } from 'react'
import { renderToStaticMarkup } from 'react-dom/server'

/**
 * A Lucide icon as standalone `<svg>` markup, for renderers that draw images
 * rather than React elements (Cytoscape node backgrounds, MapLibre pins).
 */
export function lucideSvgMarkup(Icon: LucideIcon, props?: Omit<LucideProps, 'ref'>): string {
  return renderToStaticMarkup(createElement(Icon, props))
}
